const classPrefix = 'citate'
const dataPrefix = 'data-citate'
const $container = document.querySelector(`[${dataPrefix}]`)


export function citate() {


}
